<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.71 15.88L7.83 13L21 13C21.55 13 22 12.55 22 12C22 11.45 21.55 11 21 11L7.83 11L10.71 8.12C11.1 7.73 11.1 7.1 10.71 6.71C10.32 6.32 9.69 6.32 9.3 6.71L4.71 11.3C4.32 11.69 4.32 12.32 4.71 12.71L9.3 17.3C9.69 17.69 10.32 17.69 10.71 17.3C11.09 16.91 11.1 16.27 10.71 15.88V15.88ZM3 17L3 7C3 6.45 2.55 6 2 6C1.45 6 1 6.45 1 7L1 17C1 17.55 1.45 18 2 18C2.55 18 3 17.55 3 17Z" fill="black"/>
    </svg>
</template>

<script>
    export default {
        name: "ArrowFirstIcon"
    }
</script>

<style scoped>

</style>